import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { doc, setDoc, getDoc } from "firebase/firestore";
import GlassLoader from "../components/ui/GlassLoader";

function RegisterPage() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [done, setDone] = useState(false);

  const [loading, setLoading] = useState(false);
  const [focused, setFocused] = useState(null);
  const [shake, setShake] = useState(false);

  const register = async () => {
    const cleanUsername = username.trim();

    if (!cleanUsername || !password) {
      return triggerError("Заполни все поля");
    }

    try {
      setLoading(true);
      setError("");
      setSuccess("");

      const userRef = doc(db, "users", cleanUsername);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        return triggerError("Пользователь уже существует");
      }

      await setDoc(userRef, {
        username: cleanUsername,
        password,
        status: "",
        avatar: "",
        contacts: []
      });

      setDone(true);

setTimeout(() => {
  navigate("/login");
}, 1500);

    } catch (err) {
      console.error(err);
      triggerError("Ошибка регистрации");
    }
  };

  const triggerError = (msg) => {
    setError(msg);
    setSuccess("");
    setLoading(false);

    setShake(true);
    setTimeout(() => setShake(false), 400);
  };

  if (loading) return <GlassLoader />;

  return (
    <div style={styles.container}>
      {/* 🌫 другой фон (важно для отличия!) */}
      <div style={styles.bgGlow} />

      {/* 🔥 ЛОГО МЕНЬШЕ */}
      <img src="/logo.png" alt="logo" style={styles.logo} />

      {/* 💎 ФОРМА */}
      <div
  style={{
    ...styles.card,
    animation: shake ? "shake 0.4s" : "none",
  }}
>
  {!done ? (
    <>
      <div style={styles.title}>Создать аккаунт</div>

      <div style={styles.inputsWrap}>
        {/* ЛОГИН */}
        <div style={styles.inputGroup}>
          <input
            style={{
              ...styles.input,
              ...(focused === "username" && styles.inputFocus),
            }}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onFocus={() => setFocused("username")}
            onBlur={() => setFocused(null)}
          />
          <label
            style={{
              ...styles.label,
              ...(username && styles.labelActive),
            }}
          >
            Логин
          </label>
        </div>

        {/* ПАРОЛЬ */}
        <div style={styles.inputGroup}>
          <input
            type="password"
            style={{
              ...styles.input,
              ...(focused === "password" && styles.inputFocus),
            }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onFocus={() => setFocused("password")}
            onBlur={() => setFocused(null)}
          />
          <label
            style={{
              ...styles.label,
              ...(password && styles.labelActive),
            }}
          >
            Пароль
          </label>
        </div>

        {error && <div style={styles.error}>{error}</div>}
      </div>

      <button style={styles.button} onClick={register}>
        Создать аккаунт
      </button>

      <p onClick={() => navigate("/login")} style={styles.link}>
        Уже есть аккаунт? Войти
      </p>
    </>
  ) : (
    <div style={styles.successScreen}>
      <div className="checkmark" />
      <div style={styles.successText}>Аккаунт создан</div>
    </div>

    
  )}
</div>

<div style={styles.warning}>
  <div style={styles.warningIcon}>
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 9V13"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="12" cy="17" r="1" fill="white" />
      <path
        d="M10.29 3.86L1.82 18A2 2 0 0 0 3.55 21H20.45A2 2 0 0 0 22.18 18L13.71 3.86A2 2 0 0 0 10.29 3.86Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  </div>

  <div>
    Внимание! Регистрация проходит без запроса контактной информации, поэтому
    запоминайте и сохраняйте свои логин и пароль. Восстановить их невозможно.
  </div>
</div>

      <style>
        {`
          @keyframes shake {
            0% { transform: translateX(0); }
            25% { transform: translateX(-6px); }
            50% { transform: translateX(6px); }
            75% { transform: translateX(-4px); }
            100% { transform: translateX(0); }
          }

          @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-6px); }
            100% { transform: translateY(0px); }
          }

          .checkmark {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.3);
  position: relative;
  animation: pop 0.3s ease;
}

.checkmark::after {
  content: "";
  position: absolute;
  left: 18px;
  top: 34px;
  width: 18px;
  height: 10px;
  border-left: 3px solid #8fffaf;
  border-bottom: 3px solid #8fffaf;
  transform: rotate(-45deg);
  opacity: 0;
  animation: draw 0.4s 0.2s forwards;
}

@keyframes draw {
  to {
    opacity: 1;
  }
}

@keyframes pop {
  0% { transform: scale(0.6); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}
        `}
      </style>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    background: "#050505",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    overflow: "hidden",
  },

  // ❗ ДРУГОЙ СВЕТ → сразу ощущается другой экран
  bgGlow: {
    position: "absolute",
    width: 700,
    height: 700,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.03)",
    filter: "blur(140px)",
    top: "60%",
    left: "50%",
    transform: "translateX(-50%)",
  },

  logo: {
    width: 260, // ❗ меньше чем на логине
    marginBottom: 20,
    opacity: 0.85,
    animation: "float 4s ease-in-out infinite",
  },

  title: {
    fontSize: 18,
    opacity: 0.8,
    textAlign: "center",
  },

  card: {
    width: 360,
    maxWidth: "90%",
    padding: 28,
    borderRadius: 24,
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.08)",
    backdropFilter: "blur(30px)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 16,
    boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
  },

  inputsWrap: {
    width: "100%",
    maxWidth: 260,
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },

  inputGroup: {
    position: "relative",
    width: "100%",
  },

  input: {
    width: "100%",
    padding: "16px 12px 8px",
    borderRadius: 14,
    border: "1px solid rgba(255,255,255,0.1)",
    background: "rgba(255,255,255,0.05)",
    color: "#fff",
    outline: "none",
    boxSizing: "border-box",
  },

  inputFocus: {
    border: "1px solid rgba(255,255,255,0.3)",
    boxShadow: "0 0 18px rgba(255,255,255,0.12)",
  },

  label: {
    position: "absolute",
    left: 14,
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: 14,
    color: "rgba(255,255,255,0.5)",
    transition: "0.25s",
  },

  labelActive: {
    top: -18,
    fontSize: 11,
    background: "#2e2e2e",
    padding: "0 4px",
    borderRadius: 6,
  },

  button: {
    width: "100%",
    padding: 14,
    borderRadius: 14,
    border: "1px solid rgba(255,255,255,0.25)",
    background: "linear-gradient(180deg, rgba(255,255,255,0.2), rgba(255,255,255,0.08))",
    color: "#fff",
    fontWeight: 600,
    cursor: "pointer",
  },

  error: {
    color: "#ff6b6b",
    textAlign: "center",
    fontSize: 13,
  },

  success: {
    color: "#8fffaf",
    textAlign: "center",
    fontSize: 13,
  },

  link: {
    textAlign: "center",
    fontSize: 13,
    opacity: 0.6,
    cursor: "pointer",
  },

  successScreen: {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 16,
  padding: "30px 0",
},

successText: {
  fontSize: 16,
  color: "#8fffaf",
  opacity: 0.9,
},

warning: {
  marginTop: 20,
  maxWidth: 420,
  padding: "12px 14px",
  borderRadius: 14,

  display: "flex",
  gap: 10,
  alignItems: "flex-start",

  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.08)",

  fontSize: 12,
  lineHeight: 1.4,
  opacity: 0.8
},

warningIcon: {
  marginTop: 2,
  opacity: 0.7,
},
};

export default RegisterPage;